import React from 'react'

const DispatchView = () => {
  return (
    <div>DispatchView</div>
  )
}

export default DispatchView